export const sections = [
  {
    title: "Establishing the Background",
    description: "Let's start by understanding your early life experiences.",
    questions: [
      "How would you describe your family growing up?",
      "What was it like growing up in your home?",
      "What were your early experiences with faith or religion?",
      "What were your biggest influences during childhood?"
    ]
  },
  {
    title: "Life Before Jesus",
    description: "Reflect on your life before knowing Jesus.",
    questions: [
      "What did you place your hope in?",
      "How did you view God during this time?",
      "What were your biggest struggles?",
      "What were you searching for?",
      "What did success look like to you then?"
    ]
  },
  {
    title: "The Turning Point (Meeting Jesus as the True Hero)",
    description: "Share about your journey to faith in Christ.",
    questions: [
      "What events led to your encounter with Jesus?",
      "How did you come to understand your need for Christ?",
      "What was your conversion experience like?"
    ]
  },
  {
    title: "Challenges & Growth (The Journey of Transformation)",
    description: "Reflect on your ongoing journey of growth and transformation.",
    questions: [
      "What parts of your old life have been transformed? What parts are still a work in progress?",
      "What have been your biggest challenges in following Christ?",
      "How has your understanding of God changed over time?"
    ]
  },
  {
    title: "Living with Christ in You",
    description: "Share about your current walk with Christ.",
    questions: [
      "How would you describe your relationship with Jesus today?",
      "What spiritual practices help you stay connected to God?",
      "How has your purpose in life changed?"
    ]
  },
  {
    title: "Encouragement for Others",
    description: "Share your words of encouragement for others on their journey.",
    questions: [
      "What would you say to someone who is searching for God?",
      "What scripture has been most meaningful in your journey?",
      "What advice would you give to a new believer?"
    ]
  }
];

export const getTotalQuestions = () => {
  return sections.reduce((total, section) => total + section.questions.length, 0);
};

export const getSectionProgress = (responses, sectionIndex) => {
  if (!responses[sectionIndex]) return 0;
  const answered = responses[sectionIndex].filter(r => r?.trim()).length;
  return (answered / responses[sectionIndex].length) * 100;
}; 